export const getSpecYears = state => state.result.specYears;
